interface HearthGlowProps {
  /** Any CSS color; defaults to the success-100 bloom used behind peace heroes */
  color?: string
  /** Center of the bloom, e.g. '50% 28%' */
  position?: string
  radius?: number
}

/**
 * A soft radial bloom placed behind hero content — an organic pool of light,
 * not a linear gradient slab. Parent must be `relative`; content above needs
 * `relative` (or a z-index) to sit over it.
 */
export function HearthGlow({
  color = 'rgb(220 238 227 / 0.85)',
  position = '50% 28%',
  radius = 220,
}: HearthGlowProps) {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 rounded-[inherit]"
      style={{
        background: `radial-gradient(${radius}px at ${position}, ${color}, transparent 70%)`,
      }}
    />
  )
}
